import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { isIOS } from 'react-device-detect'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import SelectActionType
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/SelectActionType/SelectActionType'
import SelectActionTypeIOS from '@app/components/MyAutomation/Tabs/iOS/CreateAction/SelectActionType/SelectActionType'
import { withAccessDenied, withNotifications } from '@app/hocs'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? SelectActionTypeIOS : SelectActionType

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    isAdditionalActionMode, sceneMode, isSaveSceneDraftPopupOpen, isEditActionMode, sceneActionTypes, initialAction,
  } = state.scenes.currentSceneCreating
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isMobile,
    path,
    isAdditionalActionMode,
    sceneMode,
    isSaveSceneDraftPopupOpen,
    isEditActionMode,
    sceneActionTypes,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectActionTypeEnhanced = enhance

export default SelectActionTypeEnhanced
